const customReportsReducer = (state: any, action: any) => {
  switch (action.type) {
    case "UPDATE_ALL_CONFIGS":
      return {
        ...state,
        ...action.payload,
        updateSource: action.source
      };
    case "UPDATE_REPORT_DETAIL":
      return {
        ...state,
        detail: action.payload,
        updateSource: action.source
      };
    case "UPDATE_ROW_DATA":
      return {
        ...state,
        rowData: action.payload,
        updateSource: action.source
      };
    case "UPDATE_DATASET_CONFIG":
      return {
        ...state,
        datasetConfig: action.payload,
        updateSource: action.source
      };
    case "UPDATE_COLUMN_CONFIG":
      return {
        ...state,
        columnConfig: action.payload,
        updateSource: action.source
      };
    case "UPDATE_GRID_STATE":
      return {
        ...state,
        gridState: { ...state.gridState, ...action.payload },
        updateSource: action.source
      };
    case "UPDATE_GRID_STATS_BADGE":
      return {
        ...state,
        gridStatusBudge: action.payload,
        updateSource: action.source
      };
    case "UPDATE_PERMISSIONS":
      return {
        ...state,
        permissions: action.payload,
        updateSource: action.source
      };
    default:
      return state;
  }
};

export default customReportsReducer;
